<template>

    <div v-if="user" style="height: 100%;">
      <div :style="'width: 100%; height: 100%; position: relative;'">
          <div class="rgcf-body">
  
              <div class="rgcf-contact-form" :style="'max-width: 700px;'">
                  <div class="shadow p-6" style="background: #FFFFFF;">
                      <div class="pt-4">
                        <p class="mb-1 text-xs mb-4"><strong>
                          Upload your contacts using the form below.
                        </strong></p>
  
                        <div v-if="success" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4" role="alert">
                        {{success}}
                        </div>

                        <div v-if="error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                        {{error}}
                        </div>

                        <div class="mb-6">
                        <input name="csv" placeholder="Test" ref="file" class="block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white border-2 border-dashed border-grey-light hover:border-grey px-2 py-2 rounded" type="file">
                        </div>

                        <p class="text-xs text-gray-700 mb-4">Your CSV file should be in the following format. Please make sure Header and Fields match.</p>

                        <table class="w-full rg-datatable">
                        <thead>
                            <tr class="">
                            <th>First</th>
                            <th>Last</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Date</th>
                            <th>Tags</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>Brian</td>
                            <td>Adams</td>
                            <td>info1@example.com</td>
                            <td>+123456781</td>
                            <td>2019-03-25 12:00:00 </td>
                            </tr>
                            <tr>
                            <td>David</td>
                            <td></td>
                            <td>info2@example.com</td>
                            <td></td>
                            <td></td>
                            <td>tag1, tag2</td>
                            </tr>
                            <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>+123456783</td>
                            <td>2019-04-22 12:00:00</td>
                            <td>tag3</td>
                            </tr>
                            <tr>
                            <td></td>
                            <td></td>
                            <td>info4@example.com</td>
                            <td>+123456784</td>
                            <td>2019-05-22 12:00:00</td>
                            </tr>
                        </tbody>
                        </table>

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': uploading}" @click="upload">
                            UPLOAD
                        </button>
  
                        <br clear="all" /><br clear="all" />
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  
  </template>
  
  <script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  
  import { VueEditor } from "vue2-editor";
  
  export default {
    metaInfo () {
      return {
        title: "Connect Social Accounts | " + this.$appName
      }
    },
    components: {
      PanelNavigation,
      VueEditor
    },
    data () {
      return {
  
          user: null,
  
            uploading: false,
            success: null,
            error: null
      }
    },
    computed: {
      ...mapState({
  
      })
    },
    methods: {
  
      getUser: async function() {
          let self = this;
  
          try {
            let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/me/get-user-by-uuid?uuid=' + this.$route.params.uuid, {
            headers: {
              
            },
            })
            
              this.user = response.data.user
          }catch(e){
              console.log(e);
          }
  
          this.contactFormLoaded = true;
      },
  
      async upload() {
            this.uploading = true
            this.error = null
            try {

                let formData = new FormData();
                formData.append("csv", this.$refs.file.files[0]);
                await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/provider/csv_file/upload`, formData, {
                    headers: {
                    'Authorization': 'Bearer ' + this.user.jwt_token,
                    'Content-Type': 'multipart/form-data'
                    }
                })

                //this.hide()
                this.success = 'Contacts uploaded successfully!';
            } catch (e) {
                this.error = e.response.data.message
            }
            this.uploading = false
        }
    },
    created() {
      this.getUser()
    }
  }
  </script>
  
  <style scoped>
    @import url('https://fonts.googleapis.com/css?family=Open+Sans&family=Source+Sans+Pro&family=Roboto&family=Lato&family=PT+Sans&family=EB+Garamond&family=Raleway&family=Ubuntu&family=Montserrat&family=Courgette');
    
    a {
        text-decoration: none !important;
    }
  
    #editor1 {
        height: 120px;
    }
  
    .rgcf-header {
        width: 100%;
        min-height: 80px;
        padding: 20px;
    }
  
    .rgcf-footer {
        /* margin-top: 30px; */
        width: 100%;
        min-height: 60px;
        background-color: #f5f5f5;
        padding: 20px;
    }
  
    .rgcf-footer-text {
        font-size: 15px;
    }
  
    .rgcf-business-name {
        font-size: 20px;
    }
  
    .rgcf-subtitle {
        padding-top: 10px;
        font-size: 14px;
    }
  
    .rgcf-body {
        /* background-color: #f5f5f5; */
        width: 100%;
        /* max-width: 1200px; */
        margin: auto;
        padding: 20px;
        min-height: calc(100% - 165px);
    }
  
    .rgcf-contact-form {
        width: 100%;
        max-width: 800px;
        margin: auto;
        padding-top: 40px;
        padding-bottom: 40px;
    }
  
    .rgcf-confirmation-text {
        padding: 30px;
        text-align: center;
    }
  
    .rgcf-body .rgcf-logo {
        padding-top: 20px;
        padding-bottom: 10px;
        text-align: center;
    }
  
    .rgcf-body .rgcf-logo img {
        display: initial;
    }
  </style>